import {inject, Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar} from '@angular/material/snack-bar';
import {RouterLinkSnackBarConfig, SNACK_BAR_TIMEOUT_MILLISECONDS} from '@aviary/store/snack-bar/snack-bar.types';
import {RouterLinkSnackBarComponent} from '@aviary/components/router-link-snack-bar/router-link-snack-bar.component';
import {OneOrArrayOf} from '@aviary/store/utility-type.helpers';

@Injectable({providedIn: 'root'})
export class SnackBarService {

  private snackBar: MatSnackBar = inject(MatSnackBar);

  private snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    duration: SNACK_BAR_TIMEOUT_MILLISECONDS
  };

  public show(message: string, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.openSnackBar(message, undefined, action);
  }

  public showSuccess(message: string, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.openSnackBar(message, 'mx-snack-bar-success', action);
  }

  public showError(message: string, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.openSnackBar(message, 'mx-snack-bar-error', action);
  }

  public showCenteredMultilineSuccess(lines: string[]): MatSnackBarRef<TextOnlySnackBar> {
    return this.openSnackBar(lines.join('\n'), ['mx-snack-bar-success', 'mx-snack-bar-centered-multiline']);
  }

  public showCenteredMultilineError(lines: string[]): MatSnackBarRef<TextOnlySnackBar> {
    return this.openSnackBar(lines.join('\n'), ['mx-snack-bar-error', 'mx-snack-bar-centered-multiline']);
  }

  public showWithRouterLink(config: RouterLinkSnackBarConfig): MatSnackBarRef<RouterLinkSnackBarComponent> {
    return this.openSnackBarWithRouterLink(config);
  }

  public showSuccessWithRouterLink(config: RouterLinkSnackBarConfig): MatSnackBarRef<RouterLinkSnackBarComponent> {
    return this.openSnackBarWithRouterLink(config, 'mx-snack-bar-success');
  }

  public showErrorWithRouterLink(config: RouterLinkSnackBarConfig): MatSnackBarRef<RouterLinkSnackBarComponent> {
    return this.openSnackBarWithRouterLink(config, 'mx-snack-bar-error');
  }

  public hide(): void {
    this.snackBar.dismiss();
  }

  private openSnackBar(message: string, panelClass?: OneOrArrayOf<string>, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(
      message,
      action,
      {
        panelClass,
        ...this.snackBarConfig
      }
    );
  }

  private openSnackBarWithRouterLink(config: RouterLinkSnackBarConfig, panelClass?: string): MatSnackBarRef<RouterLinkSnackBarComponent> {
    return this.snackBar.openFromComponent<RouterLinkSnackBarComponent, RouterLinkSnackBarConfig>(
      RouterLinkSnackBarComponent,
      {
        panelClass,
        data: config,
        ...this.snackBarConfig
      }
    );
  }
}
